import React, { createContext, useContext, useEffect, useState } from 'react';
import { getRecaptchaConfig, resetRecaptchaConfig } from '../services/recaptchaConfig';

const RecaptchaContext = createContext({ config: null, error: null, loading: true });

export function RecaptchaConfigProvider({ children }) {
  const [state, setState] = useState({ config: null, error: null, loading: true });
  const loadConfig = () => {
    getRecaptchaConfig()
      .then(config => setState({ config, error: null, loading: false }))
      .catch(error => setState({ config: null, error, loading: false }));
  };
  useEffect(() => {
    loadConfig();
  }, []);
  const retry = () => {
    resetRecaptchaConfig();
    setState({ config: null, error: null, loading: true });
    loadConfig();
  };
  return <RecaptchaContext.Provider value={{ ...state, retry }}>{children}</RecaptchaContext.Provider>;
}

export function useRecaptchaConfig() {
  return useContext(RecaptchaContext);
}
